module.exports = __webpack_public_path__ + "./src/assets/formulaireRisque.5cd4c9b7.pdf";